import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClarityWindow } from '../ms-clarity.module';

@Injectable({
    providedIn: 'root',
})
export class CookieConsentService {
    private readonly storageKey: string = 'cookie-consent';
    private readonly consentValue: string = 'yes';

    public cookiesAccepted$ = new BehaviorSubject<boolean | null>(null);

    init(): void {
        const hasConsent = this.hasConsent();

        if (hasConsent) {
            this.grantConsentOnClarity();
        }

        this.cookiesAccepted$.next(hasConsent);
    }

    hasConsent(): boolean {
        const consent = localStorage.getItem(this.storageKey);
        return consent != null && consent === this.consentValue;
    }

    acceptCookies(): void {
        localStorage.setItem(this.storageKey, this.consentValue);
        this.cookiesAccepted$.next(true);

        this.grantConsentOnClarity();
    }

    grantConsentOnClarity(): void {
        const clarityWindow = window as unknown as ClarityWindow;

        clarityWindow.clarity('consentv2', {
            ad_Storage: 'granted',
            analytics_Storage: 'granted',
        });
    }
}
